import styled from "styled-components";
import { H3, P } from "@/lib/styles";
import { forwardRef } from "react";
import CallToAction from "@/components/Button";
import { SVGArrowRight } from "@/lib/svg";

export const Container = styled.div`
  position: relative;
  margin-bottom: 0;
  ${({ theme }) => theme.mediaQueries.laptop} {
    margin-bottom: 0;
  }
`;

export const Podium = styled.div`
  padding: 1rem;
  color: ${({ theme }) => theme.colors.white};
  background-color: ${({ theme }) => theme.colors.red};
  ${({ theme }) => theme.mediaQueries.tablet} {
    position: absolute;
    top: 0;
    left: 0;
    width: calc(100% * 2 / 3 - 1.5rem * 2);
    padding: 1.5rem;
    z-index: 1;
  }
  ${({ theme }) => theme.mediaQueries.laptop} {
    width: calc(100% * 1 / 2 - 2.5rem * 2);
    padding: 2.5rem;
  }
`;

export const Heading = styled(H3)`
  margin-bottom: 1.5rem;
`;

export const Excerpt = styled(P)``;

const _Button = forwardRef<
  HTMLAnchorElement,
  { children: string; href?: string; target?: string }
>((props, ref) => (
  <CallToAction
    ref={ref}
    as="a"
    variant="primaryUnboxedNegative"
    icon={<SVGArrowRight />}
    {...props}
  />
));

_Button.displayName = "_Button";

export const Button = styled(_Button)`
  transform: translateY(20px);

  &:not(:last-child) {
    margin-bottom: 1.5rem;
  }
`;

export const ButtonsContainer = styled.div`
  float: right;
`;

export const ClearFloat = styled.div`
  clear: both;
`;

export const ImageSpacer = styled.div`
  display: none;
  ${({ theme }) => theme.mediaQueries.tablet} {
    display: block;
    height: 5rem;
  }
`;

export const ImageWrapper = styled.div`
  position: relative;
  width: calc(100% * 5 / 6);
  padding-bottom: calc((100% * 5 / 6) * 9 / 16);
  ${({ theme }) => theme.mediaQueries.tablet} {
    width: 100%;
    padding-bottom: calc(100% * 9 / 16);
  }
`;
